import { FunctionComponent, PropsWithChildren } from 'react';

interface MobilePageProps extends PropsWithChildren {}

const MobilePage: FunctionComponent<MobilePageProps> = ({ children }) => {
  return <div className="flex flex-1 flex-col">{children}</div>;
};

export default MobilePage;
